import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ofType, createEffect, Actions } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import {
  tramiteCreateFailure,
  tramiteCreateRequest,
  tramiteCreateSuccess,
  tramiteGetFailure,
  tramiteGetRequest,
  tramiteGetSuccess
} from './tramite.actions';
import { Tramite } from './tramite.models';
import { throwError } from 'rxjs';
import { TramiteService } from './tramite.service';
import { environment } from 'projects/registro-personas-empresas/src/environments/environment';
import {
  entityPersonasJuridicaAddSuccess,
  entityPersonasJuridicaChangeSuccess
} from '../empresas/entity-personas-juridica/entity-personas-juridica.actions';
import {
  entityPersonasFisicaAddSuccess,
  entityPersonasFisicaChangeSuccess
} from '../empresas/entity-personas-fisica/entity-personas-fisica.actions';
import { entityEntidadesProductivaChangeSuccess } from '../empresas/entity-entidad-productiva/entity-entidades-productiva.actions';
import { entityEntidadesProductivaTramiteChangeSuccess } from '../empresas/entidad-productiva-tramite/entidad-productiva-tramite.actions';
import { movimientoTramiteAddSuccess } from './movimiento-tramite/movimiento-tramite.actions';
import { EntityAcreditacionEmpresaAddSuccess, EntityAcreditacionEmpresaUpdateSuccess } from '../empresas/acreditacion-empresa/entity-acreditacion-empresa.actions';
// import { AlertService } from '@inase/ui';

export const TRAMITE_KEY = 'TRAMITE';

@Injectable()
export class TramiteEffect {
  tramiteCreateRequest = createEffect(
    () =>
      this.actions$.pipe(
        ofType(tramiteCreateRequest),
        switchMap((item: Tramite) => {
          return this.tramiteService.addTramite(item).pipe(
            map((tramites: Tramite) => {
              return tramiteCreateSuccess({ tramite: tramites });
            }),
            catchError((error: Error) => {
              tramiteCreateFailure({ error: error.message });
              return throwError(() => {
                throw error;
              });
            })
          );
        })
      ),
    { dispatch: true }
  );

  tramiteCreateSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(tramiteCreateSuccess),
        tap(() => {
          // this.alertService.success('Tramite registrado con éxito')
          this.router.navigateByUrl('/');
        })
      ),
    { dispatch: false }
  );

  tramiteCreateFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(tramiteCreateFailure),
        tap((error) => {
          // this.alertService.error(error.error)
        })
      ),
    { dispatch: false }
  );

  tramiteGetRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(
        tramiteGetRequest,
        entityPersonasJuridicaAddSuccess,
        entityPersonasFisicaAddSuccess,
        entityPersonasJuridicaChangeSuccess,
        entityPersonasFisicaChangeSuccess,
        entityEntidadesProductivaChangeSuccess,
        entityEntidadesProductivaTramiteChangeSuccess,
        movimientoTramiteAddSuccess,
        EntityAcreditacionEmpresaAddSuccess,
        EntityAcreditacionEmpresaUpdateSuccess,
      ),
      // Una modificación de "Datos de la Empresa" emite dos acciones en
      // sucesión inmediata (entityPersonas*ChangeSuccess y su mapeo a
      // entityEntidadesProductivaChangeSuccess). Con switchMap la segunda
      // cancelaba el GET de trámites en vuelo de la primera (aparecía
      // "cancelado" en la red y la vista quedaba desactualizada). mergeMap
      // deja que cada recarga se complete sin cancelaciones.
      mergeMap(() => {
        return this.tramiteService.getTramite().pipe(
          map((tramites: Tramite[]) => {
            return tramiteGetSuccess({ items: tramites });
          }),
          catchError((error: Error) => {
            tramiteGetFailure({ error: error.message });
            return throwError(() => {
              throw error;
            });
          })
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private router: Router,
    private tramiteService: TramiteService // private alertService: AlertService,
  ) {
    this.tramiteService.url = environment.apiUrl;
  }
}
